"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardNeoRhythmPredefined = void 0;
exports.StandardNeoRhythmPredefined = {
    focus: {
        coils: [1, 1, 1, 1, 1],
        frequency1: [33.71, 33.71, 33.71, 33.71, 33.71],
        frequency2: [54, 54, 54, 54, 54],
        intensity: [2.5, 2.5, 2.5, 2.5, 2.5],
        code: '0',
        type: 'predefined',
        device: 'NeoRhythm',
    },
    energize: {
        coils: [1, 1, 1, 1, 1],
        frequency1: [40.5, 40.5, 40.5, 40.5, 40.5],
        frequency2: [54, 54, 54, 54, 54],
        intensity: [2.5, 2.5, 2.5, 2.5, 2.5],
        code: '1',
        type: 'predefined',
        device: 'NeoRhythm',
    },
};
//# sourceMappingURL=stimulation.js.map